<aside class="m-sidebar">
  <div class="m-sidebar__header">
    <div class="m-sidebar__logo">
      <img src="assets/images/logo-icon-new.png" class="m-sidebar__logoImage" />
      <span class="m-sidebar__logoText">Stef Connect</span>
    </div>
  </div>

  <nav class="m-sidebar__nav">
    <div class="m-sidebar__navTitle">Configuration</div>
    <a
      routerLink="/global"
      routerLinkActive="m-sidebar__link -active"
      class="m-sidebar__link m-sidebar__linkFeature"
    >
      <mat-icon class="m-sidebar__linkIcon">settings</mat-icon>
      <span class="m-sidebar__linkText">{{ 'SIDEBAR.GLOBAL' | translate }}</span>
    </a>
    <a
      routerLink="/evaluation"
      routerLinkActive="m-sidebar__link -active"
      class="m-sidebar__link m-sidebar__linkFeature"
    >
      <mat-icon class="m-sidebar__linkIcon">star_rate</mat-icon>
      <span class="m-sidebar__linkText">{{ 'SIDEBAR.EVALUATION' | translate }}</span>
    </a>
    <a
      routerLink="/enseignes"
      routerLinkActive="m-sidebar__link -active"
      class="m-sidebar__link m-sidebar__linkFeature"
    >
      <mat-icon class="m-sidebar__linkIcon">store</mat-icon>
      <span class="m-sidebar__linkText">{{ 'SIDEBAR.ENSEIGNES' | translate }}</span>
    </a>
    <a
      routerLink="/nexpe"
      routerLinkActive="m-sidebar__link -active"
      class="m-sidebar__link m-sidebar__linkFeature"
    >
      <mat-icon class="m-sidebar__linkIcon">local_shipping</mat-icon>
      <span class="m-sidebar__linkText">{{ 'SIDEBAR.NEXPE' | translate }}</span>
    </a>
    <a
      routerLink="/nouveautes"
      routerLinkActive="m-sidebar__link -active"
      class="m-sidebar__link m-sidebar__linkFeature"
    >
      <mat-icon class="m-sidebar__linkIcon">new_releases</mat-icon>
      <span class="m-sidebar__linkText">{{ 'SIDEBAR.NOUVEAUTES' | translate }}</span>
    </a>
    <a
      routerLink="/utilisateurs"
      routerLinkActive="m-sidebar__link -active"
      class="m-sidebar__link m-sidebar__linkFeature"
    >
      <mat-icon class="m-sidebar__linkIcon">people</mat-icon>
      <span class="m-sidebar__linkText">{{ 'SIDEBAR.UTILISATEURS' | translate }}</span>
    </a>
  </nav>

  <div class="m-sidebar__footer">
    <div class="m-sidebar__langContainer">
      <button
        type="button"
        class="m-sidebar__langSelector"
        (click)="toggleLangMenu()"
        [attr.aria-label]="'Sélectionner la langue'"
      >
        <mat-icon class="m-sidebar__langIcon">language</mat-icon>
        <span class="m-sidebar__langCurrent">
          {{ currentLang() === 'fr' ? 'Français' : 'English' }}
        </span>
        <mat-icon
          class="m-sidebar__langArrow"
          [class.m-sidebar__langArrow--open]="isLangMenuOpen()"
        >
          expand_more
        </mat-icon>
      </button>

      @if (isLangMenuOpen()) {
        <div class="m-sidebar__langMenu">
          @for (lang of availableLanguages; track lang.code) {
            <button
              type="button"
              class="m-sidebar__langOption"
              [class.m-sidebar__langOption--active]="currentLang() === lang.code"
              (click)="switchLanguage(lang.code)"
            >
              <span class="m-sidebar__langOptionLabel">{{ lang.label }}</span>
              @if (currentLang() === lang.code) {
                <mat-icon class="m-sidebar__langCheck">check</mat-icon>
              }
            </button>
          }
        </div>
      }
    </div>
    <div class="m-sidebar__user">
      <div class="m-sidebar__userAvatar">
        {{ userInitial() }}
      </div>
      <div class="m-sidebar__userInfo">
        <p class="m-sidebar__userName">{{ userName() }}</p>
        <p class="m-sidebar__userEmail">{{ userEmail() }}</p>
      </div>
      <button type="button" class="m-sidebar__logoutBtn" (click)="logout.emit()">
        <mat-icon>logout</mat-icon>
      </button>
    </div>
  </div>
</aside>
